import {
    GET_LOGIN,
    GET_AUTH,
    GET_AUTH_REFUSE,
    GET_LOGOUT,
} from "../types/types";

const initialState = {
    User: {},
    Error: "",
    isLogin: false,
};

export const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_LOGIN:
            return {
                ...state,
                User: action.payload,
                isLogin: true,
            };
        case GET_AUTH:
            return {
                ...state,
                User: action.payload,
                isLogin: true,
            };
        case GET_AUTH_REFUSE:
            return {
                ...state,
                isLogin: false,
            };
        case GET_LOGOUT:
            return {
                isLogin: false,
            };
        default:
            return state;
    }
};
